// extracted by mini-css-extract-plugin
export default {"dropdowns":"DurationSelector_dropdowns__Uw77t"};